import { render, staticRenderFns } from "./App.vue.js?vue&type=template&id=adc4887c&scoped=true!=!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=adc4887c&scoped=true"
import script from "./App.vue.js?vue&type=script&lang=js!=!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js"
export * from "./App.vue.js?vue&type=script&lang=js!=!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue.scss?vue&type=style&index=0&id=adc4887c&prod&lang=scss&scoped=true!=!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=style&index=0&id=adc4887c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc4887c",
  null
  
)

export default component.exports